<template>
  <sidebar
    :addTitle="$t('GradeControl.MaterialSubType.AddNew')"
    :editTitle="$t('GradeControl.MaterialSubType.Edit')"
    :isSidebarActive="isSidebarActive"
    :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.MaterialSubType.Name')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('GradeControl.MaterialSubType.Name')"
                v-model="materialSubTypeName"
              ></validated-input>
               <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.MaterialSubType.Code')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('GradeControl.MaterialSubType.Code')"
                v-model="materialSubTypeCode"
              ></validated-input>
               <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
             <form-label>{{$t('GradeControl.Timesheet.MaterialType')}}</form-label>
              <ValidationProvider :name="$t('GradeControl.Timesheet.MaterialType')" rules="required" v-slot="{ errors }">
                <v-select
                  label="name"
                  :options="materialTypes"
                  v-model="materialSubTypeMaterialType"
                  :reduce="materialType => materialType.id"
                  class="w-full"
                />
                <validation-message
                  >{{ errors[0] }}</validation-message>
              </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="12">
            <vs-checkbox v-model="materialSubTypeIsActive" class="mb-2">{{$t('GradeControl.MaterialSubType.IsActive')}}</vs-checkbox>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import {
  ValidatedInput,
  ValidationMessage,
  Sidebar,
  FormLabel
} from "@/app/shared/components";
import vSelect from 'vue-select'
import MaterialTypeEnum  from "../../../MaterialTypeEnum.js";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar,
    vSelect,
    FormLabel
  },
  data() {
    return {
      materialSubTypeTypeId: 0,
      materialSubTypeName: "",
      materialSubTypeCode: "",
      materialSubTypeMaterialType: MaterialTypeEnum.Ore,
      materialSubTypeIsActive: true,
      materialTypes: MaterialTypeEnum.definition
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { materialSubTypeId, name, code, materialType, isActive } = JSON.parse(JSON.stringify(this.data));
      this.materialSubTypeId = materialSubTypeId;
      this.materialSubTypeName = name;
      this.materialSubTypeCode = code;
      this.materialSubTypeMaterialType = materialType;
      this.materialSubTypeIsActive = isActive;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.materialSubTypeCode = "";
      this.materialSubTypeName = "";
      this.materialSubTypeId = 0;
      this.materialSubTypeIsActive = true;
      this.materialSubTypeMaterialType = MaterialTypeEnum.Ore;
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            materialSubTypeId: this.materialSubTypeId,
            code: this.materialSubTypeCode,
            name: this.materialSubTypeName,
            materialType: this.materialSubTypeMaterialType,
            isActive : this.materialSubTypeIsActive,
            projectId: this.projectId
          };

          this.$vs.loading();
          if (this.materialSubTypeId !== null && this.materialSubTypeId > 0) {
            this.$store.dispatch("gradeControl/updateMaterialSubType", obj).then(() => {
              this.$emit("onMaterialSubTypeUpdated", obj);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("gradeControl/addMaterialSubType", obj).then(() => {
              this.$emit("onMaterialSubTypeInserted", obj);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
